import React from "react";

const BlogPost = ({ post }) => {
  return (
    <div className="bg-white shadow-md rounded-lg p-6 m-4">
      <h2 className="text-xl font-bold mb-2">{post.title}</h2>
      <p className="text-gray-700 mb-4">{post.content}</p>
      <div className="flex items-center justify-between">
        <p className="text-gray-500">{post.author}</p>
        <p className="text-gray-500">{post.date}</p>
      </div>
    </div>
  );
};

export default BlogPost;
